import React, {FC, ReactNode, useMemo} from 'react'
import {Link} from 'react-router-dom'
import DOMPurify from 'dompurify'
import 'react-quill/dist/quill.snow.css'
import '../public.css'
import {IPublicJobModel} from '../../hr/job/JobModel'
import {companyPath, IPublicCompanyModel} from '../PublicModels'
import {PublicBanner} from '../components/PublicBanner'
import {JobMeta} from '../components/JobMeta'

type Props = {
  job: IPublicJobModel
  company: IPublicCompanyModel
  /** Sağ sütun: ilan sayfasında "Başvur" kartı, başvuru sayfasında form */
  aside: ReactNode
}

/** İlan bilgileri solda, aside sağda (ilan ve başvuru ekranlarının ortak düzeni) */
export const PublicJobLayout: FC<Props> = ({job, company, aside}) => {
  // Açıklama kayıtta sunucuda temizleniyor; burada da gösterim öncesi tekrar temizlenir
  const descriptionHtml = useMemo(() => DOMPurify.sanitize(job.description), [job.description])

  return (
    <div className='pc-page pb-20'>
      <PublicBanner headerDocumentId={company.headerDocumentId} compact />

      <div className='pc-container'>
        <div className='d-flex flex-wrap align-items-start justify-content-between gap-6 pt-10'>
          <div>
            <h1 className='pc-title'>{job.title}</h1>
            {job.subTitle && <div className='pc-subtitle'>{job.subTitle}</div>}
          </div>
          {company.slug && (
            <Link to={companyPath(company.slug)} className='pc-btn-secondary'>
              Açık Pozisyonlara Dön
            </Link>
          )}
        </div>

        <div className='row g-10 mt-2'>
          <div className='col-lg-7'>
            <div className='mt-6'>
              <JobMeta job={job} />
            </div>

            <h2 className='fs-2 fw-semibold mt-12 mb-0'>İlan Detayı</h2>
            <div className='pc-divider'></div>

            <div className='ql-snow'>
              <div
                className='ql-editor p-0 pc-description'
                dangerouslySetInnerHTML={{__html: descriptionHtml}}
              />
            </div>
          </div>

          <div className='col-lg-5'>
            <div className='pc-sticky'>{aside}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
